<template>
  <app-section-wrap :modifier="'login two-factor'">
    <div column="xs-12 s-12 m-8 +m-2 xl-6 +xl-3">
      <div class="card">
        <h1
          class="_text-center _mbs"
        >Two-Factor Authentication</h1>
        <p
          v-if="authfailed && !disabled"
          class="alert _mt0 lips"
          role="alert"
        >{{errorMessage}}</p>
        <p
          v-else-if="disabled"
          class="alert _mt0 lips"
          role="alert"
        >{{errorMessage}}</p>
        <form @submit.prevent="verifyTwoFactor">
          <div class="form-group">
            <label for="token">Verification Code:</label>
            <input
              type="text"
              id="token"
              name="authToken"
              value=""
              required
              v-model="authToken"
            >
          </div>
          <async-button
            type="submit"
            class="_mtxs --sm"
            :executing="submitting"
            :disabled="disabled"
          >
            <template #buttonContent>
              <span>sign in</span>
            </template>
          </async-button>
          <router-link
            v-if="disabled"
            to="/"
          >Back to Sign In screen</router-link>
        </form>
      </div>
    </div>
  </app-section-wrap>
</template>
<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import LoginApi from '@api/LoginApi'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import {
    EXCEEDED_ATTEMPTS,
    MUST_ACCEPT_TAC,
    TOKEN_VERIFIED
  } from '@api/Statuses'

  export default {
    components: {
      AppSectionWrap,
      AsyncButton
    },
    data() {
      return {
        userId: 'C05957',
        errorMessage: '',
        disabled: false,
        authfailed: false,
        submitting: false,
        authToken: ''
      }
    },
    computed: {
      formObject() {
        return {
          userId: this.userId,
          token: this.authToken
        }
      }
    },
    methods: {
      verifyTwoFactor() {
        this.submitting = true
        new LoginApi().verifyToken({
          // params: { success: true },
          // params: { invalid: true },
          // params: { expired: true },
          // params: { exceeded: true },
          params: { tacReq: true },
          body: this.formObject
        })
          .then(resp => {
            switch (resp.status) {
            case TOKEN_VERIFIED:
              this.$router.push({ name: 'dashboard-prompt' })
              break
            case MUST_ACCEPT_TAC:
              this.$router.push({ name: 'terms' })
              break
            }
          })
          .catch(err => {
            err.response.json().then(json => {
              this.errorMessage = json.userMessage
              this.submitting = false
              this.authfailed = true

              // Todo we may not be able to do this.
              if (json.status === EXCEEDED_ATTEMPTS) {
                this.disabled = true
              }
            })
          })
      }
    }
  }
</script>
